import { useState } from 'react'
import {
  Button,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
  ModalProps,
  Spinner,
} from '@ritualco/jutsu'
import { useWorkspaceMerchantsQuery } from 'api/endpoints/merchant'
import { HeraModal } from 'components/HeraModal'
import { Pagination } from 'components/Pagination'
import { MerchantManageTable } from 'components/Tables/MerchantManageTable'
import { useContent } from 'lib/content/react'
import { Merchant } from 'types/entities'
import { INITIAL_ROWS_PER_PAGE } from 'config'

export type MerchantListManageModalProps = {
  organizationId: string
  workspaceId: string
  merchants: Merchant[]
  onAdd: (merchantId: string) => void
  onRemove: (merchantId: string) => void
} & Omit<ModalProps, 'children'>

export const MerchantListManageModal = (
  props: MerchantListManageModalProps
) => {
  const {
    organizationId,
    workspaceId,
    merchants,
    onAdd,
    onRemove,
    onClose,
    ...modalProps
  } = props
  const { formatMessage } = useContent()
  const [rowsPerPage, setRowsPerPage] = useState<number>(INITIAL_ROWS_PER_PAGE)
  const [pageToken, setPageToken] = useState({})
  const { status, data } = useWorkspaceMerchantsQuery({
    organizationId,
    workspaceId,
    limit: rowsPerPage,
    ...pageToken,
  })

  const showPagination = !!data?.results?.length

  return (
    <HeraModal size="4xl" onClose={onClose} {...modalProps}>
      <ModalHeader>
        {formatMessage({ id: 'pmportal.restaurantLists.manageRestaurants' })}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        {status === 'loading' ? (
          <Spinner />
        ) : (
          <>
            <MerchantManageTable
              workspaceMerchants={data?.results}
              merchants={merchants}
              onAdd={onAdd}
              onRemove={onRemove}
            />
            {showPagination && (
              <>
                <Pagination
                  hasNext={data?.hasNextPage}
                  hasPrev={data?.hasPreviousPage}
                  onNext={() => {
                    setPageToken({ nextPageToken: data?.paginationToken })
                  }}
                  onPrev={() => {
                    setPageToken({ previousPageToken: data?.paginationToken })
                  }}
                  onRowsPerPageChange={e =>
                    setRowsPerPage(Number(e.target.value))
                  }
                  rowsPerPage={rowsPerPage}
                  pt={3}
                  pb={6}
                />
              </>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionDone' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
